import TimetableCellDetails from 'src/mixins/timetable/TimetableCellDetails.js'
import timeGridRendering from 'src/mixins/timeGrid/timeGridRendering.js'
import Timetable from 'src/api/timetable.js'

const getLessonByParams = {
  data: () => ({
    timerange: {},
    allLessons: []
  }),
  mixins: [TimetableCellDetails, timeGridRendering],
  methods: {
    getLessonByEntity (beginsAt, endsAt) {
      const lessons = this.allLessons

      const intervalBeginsAt = typeof beginsAt === 'number' ? beginsAt : this.$moment(beginsAt).unix()
      const intervalEndsAt = typeof endsAt === 'number' ? endsAt : this.$moment(endsAt).unix()

      const calcLessons = Object.values(lessons)
        // filter lessons that are in the date range
        .filter(lesson => {
          return intervalBeginsAt <= lesson.begins_at && lesson.begins_at <= intervalEndsAt
        })
        .map(lesson => {
          /*
          * FIXME:
          * This is a temporary fix for the bug that the lesson's timezone is not correct.
          * When winter time is in effect, this quick fix wont work anymore!
          * This is a bug in the timetable API, we need to fix!
          */
          const { lessonDateBegins, lessonDateEnds } = this.getLessonDates(lesson)

          return {
            ...lesson,
            begins_at: lessonDateBegins.unix(),
            ends_at: lessonDateEnds.unix(),

            weekday: lessonDateBegins.isoWeekday(),
            minutes_begins_at: lessonDateBegins.hour() * 60 + lessonDateBegins.minute(), // get current minute of day
            minutes_ends_at: lessonDateEnds.hour() * 60 + lessonDateEnds.minute(),
            week: lessonDateBegins.isoWeek(),

            day: lessonDateBegins.day(),

            id: `${lesson.id}-${this.$moment.unix(lesson.begins_at).startOf('day').unix()}-0`,
            lesson_id: lesson.id,
            displayEntities: this.getFormatDataFromLessons(lesson.referenced_target_lessons[0], lesson, this.selectedEntity || {})
          }
        })
      return Object.freeze(calcLessons)
    },

    async fetchByEntity (targetType, targetId, timerange, startDate, reset = false) {
      const saveTT = async (data, headers) => {
        const { lessons } = data

        // stop function if timetable is up to date
        if (headers.etag && this.etag && this.etag === headers.etag) return

        // drop all lessons on reset
        if (reset) this.allLessons = []

        // remove possible duplicates
        this.allLessons = [...this.allLessons, ...lessons].reduce((acc, lesson) => {
          if (acc.find(l => l.id === lesson.id && l.begins_at === lesson.begins_at)) return acc
          return [...acc, lesson]
        }, [])

        this.loading = false

        if (!headers.etag) return
        this.etag = headers.etag
      }

      this.timerange = timerange || this.calculateBeginsAtEndsAt(startDate)

      const url = Timetable.timetableSingleEntityTTRangeUrl(targetType, targetId, this.timerange.begins_at, this.timerange.ends_at)

      const { data, network, headers } = await this.$cacheHttp(url)

      await saveTT(data, headers)

      // Todo - Add caching to options request - this can be outdated
      const lastUploaded = this.$moment(data.last_updated_at)
      if (lastUploaded.isAfter(this.$store.state.timetable.substitutionChangeTime)) {
        this.$store.commit('timetable/SET_SUBSTITUTION_TIME', lastUploaded)
      }

      const res = await network()
      this.$store.commit('timetable/SET_SUBSTITUTION_TIME', res.data.last_updated_at)

      console.log('etags')
      if (!res || !res.data || (res.headers.etag && res.headers.etag === headers.etag)) {
        this.loading = false
        return
      }

      console.log('show new tt')

      await saveTT(res.data, res.headers)
    },

    deepFreeze (obj) {
      Object.keys(obj).forEach(prop => {
        if (typeof obj[prop] === 'object' && !Object.isFrozen(obj[prop])) this.deepFreeze(obj[prop])
      })
      return Object.freeze(obj)
    },

    getLessonDates ({ begins_at, ends_at }) {
      const lessonDateBegins = this.$moment.unix(begins_at)
      const lessonDateEnds = this.$moment.unix(ends_at)

      const offset = lessonDateBegins.utcOffset()
      const isDST = lessonDateBegins.isDST()
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      const isMexicoCity = timezone === 'America/Mexico_City' || (timezone === undefined && offset === -360) // IE11 always returns undefined, so we doublecheck with the offset
      const isIstanbul = timezone === 'Europe/Istanbul' || (timezone === undefined && offset === 180) // IE11 always returns undefined, so we doublecheck with the offset
      const isBerlinDST = offset === 120 && isDST
      const startWinterTime = this.$moment({ year: lessonDateBegins.year(), month: 9, day: 31 }).day(0) // last sunday of october
      const endWinterTime = this.$moment({ year: lessonDateBegins.year(), month: 2, day: 31 }).day(0) // last sunday of march

      const isSummertime = lessonDateBegins.isBefore(startWinterTime) && lessonDateBegins.isAfter(endWinterTime)

      if (((offset === 0 && !isDST) || (isSummertime && !isBerlinDST)) && (!isIstanbul && !isMexicoCity)) {
        return {
          lessonDateBegins: lessonDateBegins.add(1, 'hours'),
          lessonDateEnds: lessonDateEnds.add(1, 'hours')
        }
      }

      // when winter time is in effect, the istanbul timezone lesson's are 1 hour to late
      if (isIstanbul && !isSummertime) {
        return {
          lessonDateBegins: lessonDateBegins.subtract(1, 'hours'),
          lessonDateEnds: lessonDateEnds.subtract(1, 'hours')
        }
      }

      return {
        lessonDateBegins,
        lessonDateEnds
      }
    }
  }
}

export default getLessonByParams
